import { FC, memo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import Input from '~/ui/components/inputs/Input';
import { fieldMax500 } from '~/ui/constants/errorMessages';
import { MAX_MEMO_LENGTH } from '../constants';

interface IProps {
  memoFieldName: string;
  disabled?: boolean;
  onMemoChange: () => void;
}

const MemoField: FC<IProps> = ({ memoFieldName, onMemoChange, disabled = false }) => {
  const {
    register,
    formState: { errors },
    clearErrors,
    setError,
    watch,
  } = useFormContext();
  const memoValue = watch(memoFieldName);

  useEffect(() => {
    if (memoValue?.length > MAX_MEMO_LENGTH) {
      setError(memoFieldName, { message: fieldMax500 });
    }
    if (errors[memoFieldName] && memoValue?.length <= MAX_MEMO_LENGTH) {
      clearErrors(memoFieldName);
    }
  }, [memoValue, memoFieldName, setError, clearErrors, errors]);

  return (
    <Input
      onChangeCallback={onMemoChange}
      tabIndex={-1}
      disabled={disabled}
      register={register}
      errors={errors}
      name={memoFieldName}
      label="Memo"
    />
  );
};

export default memo(MemoField);
